import Container from './CommentsBatchEdit.container';
import CommentsBatchEdit from './CommentsBatchEdit';

export default Container(CommentsBatchEdit);
